var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgInformationCircleOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 10C1.875 5.51269 5.51269 1.875 10 1.875C14.4873 1.875 18.125 5.51269 18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10ZM9.1302 8.79871C10.0854 8.32111 11.1609 9.18386 10.9019 10.2199L10.3111 12.5833L10.3456 12.566C10.6544 12.4116 11.0298 12.5368 11.1842 12.8455C11.3385 13.1542 11.2134 13.5297 10.9046 13.684L10.8701 13.7013C9.91488 14.1789 8.83936 13.3162 9.09838 12.2801L9.68922 9.91674L9.65465 9.93403C9.34591 10.0884 8.97049 9.96326 8.81612 9.65452C8.66175 9.34578 8.78689 8.97036 9.09563 8.81599L9.1302 8.79871ZM10 7.5C10.3452 7.5 10.625 7.22018 10.625 6.875C10.625 6.52982 10.3452 6.25 10 6.25C9.65482 6.25 9.375 6.52982 9.375 6.875C9.375 7.22018 9.65482 7.5 10 7.5Z",
    fill: "#FA9F34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgInformationCircleOrange);
export default __webpack_public_path__ + "static/media/svg_information_circle_orange.b0c93f0fc35ec2ff2ec2477c2abf9bce.svg";
export { ForwardRef as ReactComponent };